<template>
  <div class="container">
    <div class="el_container">
      <div class="el_main">
        <h2>我的应用</h2>
        <el-row style="background:#fff;padding:40px;" :gutter="30">
          <el-col :span="8" v-for="item in serverList" :key="item.serviceId">
            <a
              class="link"
              href="javascript:;"
            @click="goto(item)">
              <el-row>
                <el-col :span="8">
                  <el-image
                    style="width: 80px;height: 80px;border-radius: 10px;"
                    fit="cover"
                    :src="item.url ? item.url : serveUrl"
                  />
                </el-col>
                <el-col :span="16" class="appInfo">
                  <h2 :title="item.serviceName" class="ellipsis-2">{{item.serviceName}}</h2>
                  <div class="ellipsis-3">{{item.serviceDescribe}}</div>
                </el-col>
              </el-row>
            </a>
          </el-col>
        </el-row>
      </div>
      <div class="el_aside">
        <h2>个人信息</h2>
        <div>
          <div class="avatar">
            <el-image :src="userDetail.url ? userDetail.url : avatarUrl" alt />
            <p class="username">{{userDetail.realName}}</p>
            <p class="lastTime">上次登录时间：{{userDetail.lastLoginTime}}</p>
          </div>
          <div class="infos">
            <p>
              <span>手机：</span>
              <span>{{userDetail.mobile | formatData}}</span>
            </p>
            <!-- <p>
              <span>邮箱：</span>
              <span>{{userDetail.email}}</span>
            </p>-->
          </div>
          <div class="btns">
            <button class="personal" @click="toPersonal">个人资料</button>
            <button class="password" @click="toPassword">密码设置</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getPartnerId} from '@/utils/auth'
export default {
  data() {
    return {
      serverList: [],
      userDetail: {},
      avatarUrl: require('@/assets/personalCenter/avatar.png'),
      serveUrl: require('@/assets/personalCenter/server.png'),
      gotoUrl: process.env.VUE_APP_SERVICE_GOTO_URL
    }
  },
  created() {
    this.getServerList()
    this.userDetail = this.$store.state.user.userInfo
  },
  methods: {
    toPersonal() {
      this.$router.push({
        name: 'personalCenter',
        params: {
          index: '1'
        }
      })
    },
    toPassword() {
      this.$router.push({
        name: 'personalCenter',
        params: {
          index: '2'
        }
      })
    },
    goto(item){
      if(item.status==2){
        return this.$message.error("暂无此应用")
      }
      let url=item.serviceId ? `${this.gotoUrl}?serviceId=${item.serviceId}`:''
      //  window.open(item.homepageUrl)
      window.open(url)
    },
    //  class="link"
    //           :href="item.serviceId ? `${gotoUrl}?serviceId=${item.serviceId}` : ''"
    //           target="_blank"
    // 获取用户所有服务
    getServerList() {
      let config = {
        headers: { "Content-Type": "application/json;charset=UTF-8" },

      };
      this.$request({
        method: 'post',
        url: '/api/web/userrelservice/getUserServiceList',
        data:{
          ...config,
          partnerId:getPartnerId(),
          // partnerId:'1306121372718276610'
          },

      }).then(res => {
        this.serverList = res.data
      })
    }
  }
}
</script>

<style scoped lang="less">
.el_container {
  display: flex;
  width: 1445px;
  margin: auto;
  justify-content: space-between;
}
.el_container > .el_main {
  width: 1075px;
}
.el_container > .el_aside {
  width: 340px;
}
p {
  margin: 0;
}
.el_container > .el_main {
  margin-right: 30px;
  .imgBox {
    display: inline-block;
  }
  .appInfo {
    display: inline-block;
    div{
      height: 46px;
      width: 100%;
      overflow: hidden;
    }
    p {
      font-size: 12px;
      color: #999;
    }
  }
}
.el_container > .el_aside > div {
  width: 100%;
  height: 413px;
  background: rgba(255, 255, 255, 1);
  .avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-bottom: 54px;
    .el-image {
      margin-top: 36px;
      width: 80px;
      height: 80px;
      border-radius: 50%;
    }
    .username {
      font-weight: 600;
      color: rgba(74, 74, 74, 1);
      font-size: 24px;
      margin: 6px 0;
    }
    .lastTime {
      font-weight: 400;
      color: rgba(74, 74, 74, 1);
      font-size: 14px;
    }
  }
}
div.infos {
  padding-left: 22px;
  margin-bottom: 37px;
  p {
    font-weight: 400;
    color: rgba(74, 74, 74, 1);
    font-size: 14px;
    height: 20px;
    line-height: 20px;
    margin-bottom: 17px;
    span {
      margin-right: 20px;
    }
  }
}
div.btns {
  margin-left: 58px;
  button {
    width: 97px;
    height: 35px;
    background: rgba(227, 235, 255, 1);
    border-radius: 2px;
    border: 1px solid rgba(52, 107, 253, 1);
    font-weight: 400;
    color: rgba(52, 107, 253, 1);
    font-size: 14px;
    text-align: center;
    line-height: 32px;
    cursor: pointer;
  }
  .personal {
    background: #346bfd;
    color: #fff;
    margin-right: 30px;
  }
}
.link {
  display: block;
  color: #606266;
  border: 1px solid #eee;
  border-radius: 6px;
  height: 132px;
  transition: all 0.15s ease;
  &:hover {
    box-shadow: 4px 4px 10px 3px #f0f0f0;
    transform: scale(1.005);
  }
  h2 {
    margin: 0;
    margin-bottom: 10px;
    font-size: 17px;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
  }
}


</style>

<style scoped lang="less">
/deep/ .el-col {
  padding: 15px;
}
</style>
